import React from 'react'

export const ServiceCodeIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5.5 2.5h5c.83 0 1.5.67 1.5 1.5v1.5L10 7l2 1.5V10c0 .83-.67 1.5-1.5 1.5h-5A1.5 1.5 0 014 10V4c0-.83.67-1.5 1.5-1.5z"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinejoin="round"
    />
    <path
      d="M6.5 5.5v5M8 5.5v5M9.5 5.5v5"
      stroke="currentColor"
      strokeWidth="1"
      strokeLinecap="round"
    />
  </svg>
)
